export default __webpack_public_path__ + "static/media/mark.dda4ddcd.svg";